// extracted by mini-css-extract-plugin
export var dropdown = "_hb-0";
export var imagePlaceholder = "_hb-2";
export var imageWrapper = "_hb-3";
export var productImage = "_hb-1";
export var truncateContainer = "_hb-4";
export var truncateText = "_hb-5";